/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 20a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm1-5h-2v-2h2v2Zm-2-4h2V6h-2v8Z',
  DEV ? 'AlertIcon' : '',
  '',
  false,
);
